import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateBook = async (BookObject, uid, SchoolID) => {
  try {
    const LibraryCollection = collection(db, "Library");

    const data = HelperForMetaData({
      ...BookObject,
      uid: uid,
      SchoolID: SchoolID,
    });
    await addDoc(LibraryCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateBook;
